import React from "react";
import { HarvestProduct } from "../utils/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
type DesktopInventoryLayoutProps = {
  item: HarvestProduct;
  onOpenEdit: (state: boolean, id: string) => void;
  onOpenWarning: (id: string) => void;
};
const DesktopInventoryLayout = ({
  item,
  onOpenEdit,
  onOpenWarning,
}: DesktopInventoryLayoutProps) => {
  const { name, quantity, id, price, discount } = item;
  const discountedDisplay = (
    <p>
      Discount: <span className="red-highlight">{discount}%</span>
    </p>
  );
  return (
    <li className="info-card info-card-clickable">
      <div className="inventory-item">
        <div className="inventory-item-texts">
          <p>
            <span className="bold-capitalized item-header">{name}</span>
          </p>
          <p>Available: {Math.max(0, quantity)} (kg)</p>
          <div className="price-and-discount">
            <p>
              Price: <span className="bold">{price} kr</span>
            </p>
            {discount ? discountedDisplay : null}
          </div>
        </div>
        <div className="item-edit-btns">
          <button
            className="btn"
            title="Edit"
            onClick={() => onOpenEdit(true, id)}
          >
            <FontAwesomeIcon icon={faPen} style={{ color: "#ffffff" }} />
          </button>
          <button
            className="btn"
            title="Remove"
            onClick={() => onOpenWarning(id)}
          >
            <FontAwesomeIcon icon={faTrash} style={{ color: "#ffffff" }} />
          </button>
        </div>
      </div>
    </li>
  );
};

export default DesktopInventoryLayout;
